import React, {useState} from "react";
import styles from "../assets/css/menu.module.scss"
import {
    Box,
    Container,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Typography,
    useScrollTrigger,
    Drawer
} from "@mui/material";
import {Link as LinkLocation, Link, useNavigate} from "react-router-dom";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ReactDOM from 'react-dom/client';

import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {Global} from "@emotion/react";

const drawerStyle = {
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(0, 1),
    // // necessary for content to be below app bar
    // ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
};
const Menu = (props) => {
    const {window} = props;
    const navigate = useNavigate();
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 10,
    });
    const [openDrawers, setOpenDrawers] = useState(false);
    const handleDrawerOpen = () => {
        setOpenDrawers(true);
    };
    const handleDrawerClose = () => {
        setOpenDrawers(false);
    };
    return <div className={`${styles.menu} ${trigger ? styles.appBarScrolled : styles.appBarNotScrolled}`}>
        <Global
            styles={{
                '.MuiDrawer-root > .MuiPaper-root': {
                    height: `calc(50% - ${56}px)`,
                    overflow: 'visible',
                },
            }}
        />
        <div style={{direction: "ltr", textAlign: "left"}}>
            <Drawer
                anchor={'bottom'}
                open={openDrawers}
                onClose={handleDrawerClose}
                onOpen={handleDrawerOpen}
            >

                <Box
                    sx={{width: 250}}
                    role="presentation"
                    onClick={handleDrawerClose}
                    onKeyDown={handleDrawerClose}
                >
                    <List>

                        <MobileNav to='/' label='بیشتر بدانید' onClick={e => {
                            e.preventDefault();
                            navigate("/");
                            setTimeout(() => {
                                document.location.href = "#services";

                            }, 500);
                        }}/>
                        <MobileNav to='/blogs' label='بیشتر بدانید' onClick={null}/>
                        <MobileNav to='/about-us' label='چرا رامونا' onClick={null}/>
                    </List>

                </Box>

            </Drawer>
        </div>

        <Container maxWidth={"md"} className={styles.menuContainer}>
            <IconButton edge="start" onClick={handleDrawerOpen}
                        className={`${styles.mobileMenu}`}

                        style={{color:"#fff"}}
                        aria-label="menu"
            >
                <MenuRoundedIcon/>
            </IconButton>
            <div style={{width: 100, display: "flex", flexDirection: "column", justifyContent: "center",flexGrow: 8}}>
                <Link to={"/"} style={{textDecoration: "none", alignSelf: "center"}}>
                    <Typography variant={"h4"} style={{color: "#fff"}}>
                        Ramona
                    </Typography>
                </Link>
            </div>

            <div className={styles.menuInnerContainer}>
                <div className={styles.menuItemContainer}>
                    <Link to={"/blogs"} className={styles.menuItem}>
                        بیشتر بدانید
                    </Link>
                </div>
                <div className={styles.menuItemContainer}>
                    <a to={"/"} onClick={e => {
                        // let offsetTop  = document.getElementById("services").offsetTop;
                        // window.scrollTo({
                        //     top: offsetTop-100,
                        //     behavior: "smooth"
                        // });
                        e.preventDefault();
                        navigate("/");
                        setTimeout(() => {
                            document.location.href = "#services";

                        }, 500);

                    }} className={styles.menuItem}>
                        خدمات
                    </a>
                </div>

                <div className={styles.mainMenuItemContainer}>
                    <Link to={"/about-us"} className={styles.mainMenuItem}>
                        چرا رامونا
                    </Link>
                </div>
            </div>


        </Container>
    </div>
};

export default Menu;


function MobileNav({label, to, onClick, activeOnlyWhenExact}) {
    // let match = useRouteMatch({
    //     path: to,
    //     exact: activeOnlyWhenExact
    // });
    return (
        <ListItem key={label} className={`${true ? styles.activeMenuItem : null} ${styles.mobileMenu}`}>
            <ListItemText>
                {onClick!==null ? <LinkLocation to={to} className={styles.menuItem} onClick={e=>{
                        onClick(e);
                    }}>{label}</LinkLocation> :
                    <LinkLocation to={to} className={styles.menuItem}>{label}</LinkLocation>}
            </ListItemText>
        </ListItem>


    );
}